import React from 'react';
import Plane from 'react-loader-spinner';
import './Loader.css';

const Loader = () => {
    return (
        <div className="planeContainer">
            <Plane type="Plane" color="#00BFFF" height="100" width="100" />
        </div>
    );
};

export default Loader;



// WEBPACK FOOTER //
// ./src/components/Loader/Loader.js